import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';


const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'auth/signin',
        pathMatch: 'full'
      },
      {
        path: 'auth',
        loadChildren: () => import('./views/authentication/authentication.module').then(module => module.AuthenticationModule)
      },
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(module => module.DashboardModule)
      },
      {
        path: 'administration',
        loadChildren: () => import('./views/administration/administration.module').then(module => module.AdministrationModule)
      },
      {
        path: 'requests',
        loadChildren: () => import('./views/requests/requests.module').then(module => module.RequestsModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./views/reports/reports.module').then(module => module.ReportsModule)
      },
      {
        path: 'bim-administration',
        loadChildren: () => import('./views/bim-administration/bim-administration.module').then(module => module.BimAdministrationModule)
      },
      {
        path: 'company',
        loadChildren: () => import('./views/company/company.module').then(module => module.CompanyModule)
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
